import { isEmpty } from '@jjj/components';
import actions from './actions';
import { createReducer } from '../../../helpers/reducer';
import { keyBy } from '../../../helpers/core';

const initState = {
  editForm: {
    flex_privacy_policy_url: '',
    flex_terms_of_service_url: '',
    ondemand_privacy_policy_url: '',
    ondemand_terms_of_service_url: '',
  },
  total: 0,
  isLoading: false,
  isSaveRequestSending: false,
};

function validate(attr, value) {
  const error = '';

  if (
    [
      'flex_terms_of_service_url',
      'flex_privacy_policy_url',
      'ondemand_terms_of_service_url',
      'ondemand_privacy_policy_url',
    ].includes(attr) &&
    isEmpty(value)
  ) {
    return 'URL is required';
  }

  return error;
}

function onLoad(state) {
  return {
    ...state,
    isLoading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data } = payload;
  const propsArray = Object.keys(data);

  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: data[prop],
      error: validate(prop, data[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    editForm,
    isLoading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

function onSave(state) {
  return {
    ...state,
    isSaveRequestSending: true,
  };
}

function onSaveSuccess(state, { payload }) {
  const { data } = payload;
  const propsArray = Object.keys(data);
  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: data[prop],
      error: validate(prop, data[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    editForm,
    isSaveRequestSending: false,
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editForm } = state;

  editForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editForm: {
      ...editForm,
    },
  };
}

function onCancel(state) {
  return {
    ...state,
    isEdit: false,
    editForm: null,
  };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.CANCEL]: onCancel,
  [actions.SAVE]: onSave,
  [actions.SAVE_SUCCESS]: onSaveSuccess,
  [actions.TOUCH]: onTouch,
});
